module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"Overview":"Overview","Overviewtooltip":"Traffic represents the number of customer who visited the store during the selected periods. The Traffic Prediction Timeline forecasts future traffic (upto 7 days) based on numerous factors.","tooltip":""}}')
  delete Component.options._Ctor
}
